import React from 'react'
import { useSelector } from 'react-redux'

import { translate } from '~/core/translate'
import { getDialogProps, getViewedSessionId } from '~/selectors/ui'
import { getSessionSummary } from '~/selectors/session-details'
import Modal from '~/components/common/modal'
import AiBadge from '~/components/common/ai-badge'
import SummaryFeedback from './feedback'

const SummaryDialog = () => {
  const id = useSelector(getDialogProps).id ?? useSelector(getViewedSessionId)
  const { showFeedback } = useSelector(getDialogProps)
  const footerChildren = showFeedback ? <SummaryFeedback sessionId={id} /> : null
  const text = useSelector(getSessionSummary(id))

  return (
    <Modal
      footerChildren={footerChildren}
      title={translate('meeting_summary')}
      titleBadge={<AiBadge />}
    >
      {text.split('\n').map((line, i) => <p key={i}>{line}</p>)}
    </Modal>
  )
}

export default SummaryDialog
